// InfoFlow Social — contenu de demonstration statique.
// Aucune donnee reelle. Aucun fetch. Aucun appel API. demo: true.
// Sert uniquement a alimenter le showcase visuel sur la homepage et
// les surfaces dormantes tant que les flags sociaux sont a false.

export const DEMO = true;

export const PARTICIPANTS = [
  {
    id: 'amina-k',
    name: 'Amina K.',
    handle: 'amina',
    city: 'Abidjan',
    country: 'Côte d’Ivoire',
    role: 'Journaliste citoyenne',
    languages: ['Français', 'Anglais'],
    color: '#D62828',
    status: 'Actif',
  },
  {
    id: 'serge-l',
    name: 'Serge L.',
    handle: 'serge',
    city: 'Paris',
    country: 'France',
    role: 'Média / Créateur',
    languages: ['Français', 'Dida'],
    color: '#1A1A1A',
    status: 'Créateur',
  },
  {
    id: 'fatou-d',
    name: 'Fatou D.',
    handle: 'fatou',
    city: 'Dakar',
    country: 'Sénégal',
    role: 'Entrepreneure',
    languages: ['Français', 'Wolof'],
    color: '#E9C46A',
    status: 'Entrepreneure',
  },
  {
    id: 'carlos-m',
    name: 'Carlos M.',
    handle: 'carlos',
    city: 'São Paulo',
    country: 'Brésil',
    role: 'Culture',
    languages: ['Portugais', 'Français'],
    color: '#1E3A8A',
    status: 'Créateur',
  },
  {
    id: 'nadia-b',
    name: 'Nadia B.',
    handle: 'nadia',
    city: 'Casablanca',
    country: 'Maroc',
    role: 'Marketplace',
    languages: ['Arabe', 'Français'],
    color: '#D62828',
    status: 'Entrepreneure',
  },
  {
    id: 'mei-l',
    name: 'Mei L.',
    handle: 'mei',
    city: 'Singapour',
    country: 'Singapour',
    role: 'Analyste',
    languages: ['Anglais', 'Mandarin'],
    color: '#1A1A1A',
    status: 'Journaliste',
  },
  {
    id: 'oumar-t',
    name: 'Oumar T.',
    handle: 'oumar',
    city: 'Bamako',
    country: 'Mali',
    role: 'Reporter terrain',
    languages: ['Français', 'Bambara'],
    color: '#D62828',
    status: 'Reporter',
  },
  {
    id: 'sarah-m',
    name: 'Sarah M.',
    handle: 'sarah',
    city: 'Londres',
    country: 'Royaume-Uni',
    role: 'Diaspora',
    languages: ['Anglais', 'Français'],
    color: '#1E3A8A',
    status: 'Diaspora',
  },
  {
    id: 'yao-k',
    name: 'Yao K.',
    handle: 'yao',
    city: 'Accra',
    country: 'Ghana',
    role: 'Tech / Business',
    languages: ['Anglais', 'Français'],
    color: '#1A1A1A',
    status: 'Business',
  },
  {
    id: 'leyla-a',
    name: 'Leyla A.',
    handle: 'leyla',
    city: 'Istanbul',
    country: 'Turquie',
    role: 'Créatrice',
    languages: ['Turc', 'Français'],
    color: '#E9C46A',
    status: 'Créatrice',
  },
];

export const POSTS = [
  {
    id: 'post-1',
    authorId: 'amina-k',
    type: 'texte',
    text: 'Couverture citoyenne du marché de Treichville ce matin : 3 reportages courts à venir, en français et en anglais.',
    counters: { vues: 12400, ecoutes: 0, reactions: 312, commentaires: 47 },
    badges: ['Démo', 'Hermès'],
    createdAt: '2026-05-07T14:18:00Z',
    displayTime: 'Il y a 12 min',
    dateLabel: 'Aujourd’hui',
    timeLabel: '14:18',
    status: 'publié',
  },
  {
    id: 'post-2',
    authorId: 'serge-l',
    type: 'audio',
    text: 'Édito du matin — version audio bilingue. La version Dida arrive dans une heure grâce à VoixClone.',
    counters: { vues: 8200, ecoutes: 4180, reactions: 521, commentaires: 88 },
    badges: ['Audio', 'Traduction', 'Démo'],
    createdAt: '2026-05-07T08:00:00Z',
    displayTime: 'Aujourd’hui à 08:00',
    dateLabel: 'Aujourd’hui',
    timeLabel: '08:00',
    status: 'mis à jour',
  },
  {
    id: 'post-3',
    authorId: 'nadia-b',
    type: 'business',
    text: 'Nouvelle collection artisanale Casablanca → Marketplace InfoFlow. Paiement intégré bientôt.',
    counters: { vues: 5430, ecoutes: 0, reactions: 198, commentaires: 24 },
    badges: ['Démo'],
    createdAt: '2026-05-07T15:00:00Z',
    displayTime: 'Programmé · 15:00',
    dateLabel: 'Aujourd’hui',
    timeLabel: '15:00',
    status: 'programmé',
  },
  {
    id: 'post-4',
    authorId: 'carlos-m',
    type: 'video',
    text: 'Réinventer le carnaval avec les communautés numériques — Flow Reel de 60 secondes.',
    counters: { vues: 21200, ecoutes: 0, reactions: 1842, commentaires: 156 },
    badges: ['Flow Reels', 'Démo'],
    createdAt: '2026-05-07T14:30:00Z',
    displayTime: 'En direct',
    dateLabel: 'Aujourd’hui',
    timeLabel: 'En direct',
    status: 'en direct',
  },
  {
    id: 'post-5',
    authorId: 'fatou-d',
    type: 'image',
    text: 'L’atelier des entrepreneures de Dakar a ouvert ses portes. Hermès a synthétisé les 3 premiers panels.',
    counters: { vues: 6740, ecoutes: 0, reactions: 287, commentaires: 39 },
    badges: ['Hermès', 'Démo'],
    createdAt: '2026-05-07T10:15:00Z',
    displayTime: 'Aujourd’hui à 10:15',
    dateLabel: 'Aujourd’hui',
    timeLabel: '10:15',
    status: 'publié',
  },
  {
    id: 'post-6',
    authorId: 'mei-l',
    type: 'texte',
    text: 'Marchés Asie : la traduction automatique de l’analyse de ce matin est disponible en français et arabe.',
    counters: { vues: 3120, ecoutes: 980, reactions: 121, commentaires: 18 },
    badges: ['Traduction', 'Audio', 'Démo'],
    createdAt: '2026-05-06T18:42:00Z',
    displayTime: 'Hier · 18:42',
    dateLabel: 'Hier',
    timeLabel: '18:42',
    status: 'mis à jour',
  },
];

export const HERMES_SKILLS = [
  { id: 'recherche', label: 'Recherche' },
  { id: 'redaction', label: 'Rédaction' },
  { id: 'fact-checking', label: 'Fact-checking' },
  { id: 'marketing', label: 'Marketing' },
  { id: 'image', label: 'Image' },
  { id: 'video', label: 'Vidéo' },
  { id: 'audio', label: 'Audio' },
  { id: 'voixclone', label: 'VoixClone' },
  { id: 'whatsapp-reporter', label: 'WhatsApp Reporter' },
];

export const COMPOSER_OPTIONS = [
  { id: 'photo-video', label: 'Photo/Vidéo' },
  { id: 'audio', label: 'Audio' },
  { id: 'live', label: 'Live' },
  { id: 'gif', label: 'GIF' },
  { id: 'hermes', label: 'Hermès Agent' },
  { id: 'translate', label: 'Traduire' },
  { id: 'voice', label: 'Voix' },
  { id: 'product', label: 'Identifier un produit' },
  { id: 'whatsapp', label: 'WhatsApp' },
  { id: 'telegram', label: 'Telegram' },
  { id: 'invite', label: 'Inviter' },
];

export const LANGUAGE_PAIRS = [
  { id: 'fr-en', from: 'Français', to: 'Anglais' },
  { id: 'fr-ar', from: 'Français', to: 'Arabe' },
  { id: 'fr-pt', from: 'Français', to: 'Portugais' },
  { id: 'fr-tr', from: 'Français', to: 'Turc' },
];

export const VOICE_OPTIONS = [
  { id: 'male', label: 'Voix masculine' },
  { id: 'female', label: 'Voix féminine' },
  { id: 'cloned', label: 'Voix clonée autorisée' },
];

export const SOCIAL_MODULES = [
  { id: 'feed', label: 'Feed éditorial' },
  { id: 'posts', label: 'Posts premium' },
  { id: 'audio', label: 'Audio multilingue' },
  { id: 'reels', label: 'Flow Reels' },
  { id: 'creators', label: 'Créateurs & journalistes' },
  { id: 'marketplace', label: 'Marketplace' },
  { id: 'hermes', label: 'Hermès intégré' },
];

export const FLOW_REEL_DEMO = {
  id: 'reel-1',
  authorId: 'carlos-m',
  text: 'Carnaval réinventé — 60s.',
  counters: { likes: 1842, comments: 156, shares: 92 },
  badge: 'Flow Reels',
  language: 'Portugais → Français',
};

export const SOCIAL_BADGES = [
  'Hermès intégré',
  'Audio multilingue',
  'Posts premium',
  'Créateurs & journalistes',
  'Bientôt disponible',
];

export const DIFFERENTIATORS = [
  { id: 'listen-language', label: 'Écouter dans ma langue', iconKey: 'listen' },
  { id: 'hermes-everywhere', label: 'Hermès sous chaque post', iconKey: 'hermes' },
  { id: 'multiformat', label: 'Post multiformat intelligent', iconKey: 'multiformat' },
  { id: 'verified-timeline', label: 'Timeline vérifiée', iconKey: 'verified' },
  { id: 'civic-missions', label: 'Missions citoyennes', iconKey: 'mission' },
  { id: 'voiceclone', label: 'VoixClone autorisée', iconKey: 'voice' },
];

export function findParticipant(authorId) {
  return PARTICIPANTS.find((p) => p.id === authorId) || PARTICIPANTS[0];
}

export function formatCount(n) {
  if (n >= 1000000) return (n / 1000000).toFixed(1).replace(/\.0$/, '') + 'M';
  if (n >= 1000) return (n / 1000).toFixed(1).replace(/\.0$/, '') + 'k';
  return String(n);
}
